import { Col, Form, Input, Row } from 'ui';

export type MemberOrganizationsListFiltersFormValues = {
  search?: string;
};

const MemberOrganizationsListFilter = () => (
  <Row>
    <Col span={24}>
      <Form.Item<MemberOrganizationsListFiltersFormValues> label="Search" name="search">
        <Input hasSearch />
      </Form.Item>
    </Col>
  </Row>
);

export default MemberOrganizationsListFilter;
